// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mhAp","colMin":"styles_colMin__27OBb"};